/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// Reexport jen potřebných částí pro zmenšení velikosti bundle.
export { Vue as default } from '@sentry/integrations';

/**
 * Sentry integrace pro Vue.js.
 *
 * Zdroje:
 * - [Dokumentace](https://docs.sentry.io/platforms/javascript/vue/)
 * @interface SentryVueIntegration
 */
